import { IModuleChartMetrics } from '@/interfaces/powerMarkets/charts/IModuleChartConfig.ts';
import { formatMetricNumber } from './numberUtils.ts';
import { escapeHtml } from './htmlUtils.ts';

// eslint-disable-next-line
export function exportJsonToExcel (jsonData: Array<Record<string, any>>, fileName: string): void {
    const fields = Object.keys(jsonData[0]);

    let tableHTML = '<table><thead><tr>';
    fields.forEach((field) => {
        tableHTML += `<th>${escapeHtml(field)}</th>`;
    });
    tableHTML += '</tr></thead><tbody>';

    Object.values(jsonData).forEach((row) => {
        tableHTML += '<tr>';
        fields.forEach((field) => {
            const cellValue = row[field] == null ? '' : String(row[field]);
            tableHTML += `<td>${escapeHtml(cellValue)}</td>`;
        });
        tableHTML += '</tr>';
    });
    tableHTML += '</tbody></table>';

    // Excel can open HTML table data when served as "application/vnd.ms-excel"
    const dataType = 'application/vnd.ms-excel';
    const tableDataUri = `data:${dataType};charset=utf-8,${encodeURIComponent(tableHTML)}`;

    const link = document.createElement('a');
    link.href = tableDataUri;
    link.download = `${fileName}.xls`;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// eslint-disable-next-line
export function exportJsonToCSV (jsonData: Array<Record<string, any>>, fileName: string): void {

    const fields = Object.keys(jsonData[0]);

    let csvContent = `${fields.join(',')}\n`;

    Object.values(jsonData).forEach((row) => {
        const rowString = fields.map((field) => {
            const cellValue = row[field] == null ? '' : String(row[field]);
            const escaped = cellValue.replace(/"/g, '""');
            return `"${escaped}"`;
        }).join(',');

        csvContent += `${rowString}\n`;
    });

    const csvDataUri = `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;

    const link = document.createElement('a');
    link.href = csvDataUri;
    link.download = `${fileName}.csv`;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function downloadChartMetrics (
    metricData: Array<IModuleChartMetrics>,
    metricsHeaders: Array<{label: string; key: keyof IModuleChartMetrics}>,
    exportType: 'csv' | 'xls',
    title: string,
): void {
    const excel = metricData.map((el) => {
        const row: Record<string, string | number> = {};
        metricsHeaders.forEach((header) => {
            if (header.key === 'id') {
                row[header.label] = el[header.key];
            } else {
                row[header.label] = formatMetricNumber(el[header.key]);
            }
        });
        return row;
    });
    if (exportType === 'csv') {
        exportJsonToCSV(excel, title);
    } else {
        exportJsonToExcel(excel, title);
    }
}
